import * as React from 'react';

import { SingleOfferSearchButton } from '@shared-ui/lodging-property-offers';

import { SharedUiSubmitButtonWrapper } from 'components/infosite/shared-ui/form/field-wrappers';
import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const SingleOfferSearchButtonComponent: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <SingleOfferSearchButton inputs={inputs} ButtonWrapper={SharedUiSubmitButtonWrapper} skipSsr={true} />
);

SingleOfferSearchButtonComponent.displayName = 'SingleOfferSearchDateFieldComponent';

export const SharedUiSingleOfferSearchButtonWrapper = withSharedUiPropertyOffers(SingleOfferSearchButtonComponent);
